const UnlockErrorMessage = {
  NO_DEVICE_FOUND: "no device found",
  DEVICE_ALREADY_TAKEN: "cannot check out multiple scanners for user",
  SCANNER_NOT_PICKED_UP: "Scanner never picked up",
  UNLOCKING_TIMED_OUT: "Unlocking timed out",
};

export default UnlockErrorMessage;
